<template>
  <div>
    <v-dialog
      v-model="modal_add"
      persistent
      scrollable
      max-width="1000px"
      content-class="add-jabatan-dialog"
    >
      <v-card class="add-jabatan-modal" flat>
        <!-- Loading -->
        <div v-if="refpelaksana.length === 0">
          <v-skeleton-loader type="card, article" />
        </div>

        <template v-else>
          <!-- HEADER -->
          <div class="add-modal-header">
            <div class="add-header-content">
              <div class="add-header-icon">
                <v-icon size="28" color="white">
                  mdi-briefcase-plus-outline
                </v-icon>
              </div>

              <div class="add-header-text">
                <div class="add-header-eyebrow">MANAJEMEN KEPEGAWAIAN</div>

                <h2>Tambah Data Jabatan</h2>

                <p>Tambah informasi jabatan dan struktur organisasi.</p>
              </div>
            </div>

            <v-btn
              icon
              dark
              class="add-header-close"
              aria-label="Tutup modal"
              @click="close_modal"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>

          <!-- BODY -->
          <v-card-text class="add-modal-body">
            <!-- ATASAN LANGSUNG -->
            <section class="add-section">
              <div class="add-section-heading">
                <div class="add-section-icon parent-icon">
                  <v-icon>mdi-account-supervisor-outline</v-icon>
                </div>

                <div>
                  <h3>Struktur Organisasi</h3>
                  <p>Tentukan atasan langsung dari jabatan ini.</p>
                </div>
              </div>

              <v-row dense>
                <v-col cols="12" md="12">
                  <v-text-field
                    v-model="nama_unor"
                    label="Unit Organisasi"
                    prepend-inner-icon="mdi-domain"
                    outlined
                    dense
                    readonly
                    hide-details="auto"
                    class="modern-field"
                  />
                </v-col>

                <v-col cols="12" md="12">
                  <v-autocomplete
                    v-model="atasan"
                    :items="petjab"
                    item-value="id"
                    item-text="namaJabatan"
                    label="Atasan Langsung"
                    placeholder="Pilih atasan langsung"
                    prepend-inner-icon="mdi-account-arrow-up-outline"
                    outlined
                    dense
                    return-object
                    clearable
                    hide-details="auto"
                    class="modern-field"
                    no-data-text="Atasan langsung tidak ditemukan"
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item.namaJabatan }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>

                    <template v-slot:selection="{ item }">
                      <span>{{ item.namaJabatan }}</span>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="id_jab_bkn"
                    label="ID BKN"
                    prepend-inner-icon="mdi-key-outline"
                    placeholder="Masukkan ID jabatan dari BKN"
                    outlined
                    dense
                    hide-details="auto"
                    class="modern-field"
                  />
                </v-col>
              </v-row>
            </section>

            <v-divider class="add-section-divider" />

            <!-- INFORMASI JABATAN -->
            <section class="add-section">
              <div class="add-section-heading">
                <div class="add-section-icon position-icon">
                  <v-icon>mdi-card-account-details-outline</v-icon>
                </div>

                <div>
                  <h3>Informasi Jabatan</h3>
                  <p>Lengkapi jenis, rumpun, dan identitas jabatan.</p>
                </div>
              </div>

              <v-row dense>
                <!-- JENIS JABATAN -->
                <v-col cols="12" :md="sjj == 'kosong' ? 10 : 8">
                  <v-dialog v-model="modal_jenjab" scrollable max-width="650px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="sjj.nama"
                        label="Jenis Jabatan"
                        prepend-inner-icon="mdi-format-list-bulleted-type"
                        outlined
                        dense
                        readonly
                        v-on="on"
                        v-bind="attrs"
                        hide-details="auto"
                        class="modern-field"
                      />
                    </template>

                    <v-form ref="pilihjj">
                      <v-card class="jenis-jabatan-modal">
                        <div class="jenis-jabatan-header">
                          <v-icon color="primary" class="mr-3">
                            mdi-format-list-bulleted-type
                          </v-icon>

                          <div>
                            <h3>Pilih Jenis Jabatan</h3>
                            <p>Pilih kategori dan jenis jabatan yang sesuai.</p>
                          </div>
                        </div>

                        <v-divider />

                        <v-card-text class="pa-5">
                          <v-select
                            outlined
                            dense
                            return-object
                            :items="refjj"
                            @change="cjj"
                            item-key="id"
                            item-text="nama"
                            label="Kategori Jabatan"
                            hide-details="auto"
                            class="modern-field mb-4"
                          />

                          <div class="tree-selection-panel">
                            <v-treeview
                              activatable
                              return-object
                              :items="bawahan"
                              :active.sync="seljj"
                              item-key="id"
                              item-children="bawahan"
                              selection-type="independent"
                              open-on-click
                              hoverable
                            >
                              <template v-slot:prepend="{ item }">
                                <v-icon color="primary" small>
                                  mdi-briefcase-outline
                                </v-icon>
                                <span>
                                  {{ item.nama }}
                                </span>
                              </template>
                            </v-treeview>
                          </div>
                        </v-card-text>

                        <v-divider />

                        <v-card-actions class="pa-4">
                          <v-btn text color="grey darken-1" @click="clearjj">
                            <v-icon left>mdi-eraser</v-icon>
                            Reset
                          </v-btn>

                          <v-spacer />

                          <v-btn
                            text
                            color="grey darken-1"
                            @click="modal_jenjab = false"
                          >
                            Batal
                          </v-btn>

                          <v-btn depressed color="primary" @click="modal_jenjab = false">
                            <v-icon left>mdi-check</v-icon>
                            Pilih
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-form>
                  </v-dialog>
                </v-col>

                <!-- RUMPUN JABATAN -->
                <v-col cols="12" md="4">
                  <v-text-field
                    :value="sjj.kelompok"
                    label="Rumpun Jabatan"
                    prepend-inner-icon="mdi-shape-outline"
                    outlined
                    dense
                    readonly
                    hide-details="auto"
                    class="modern-field"
                  />
                </v-col>

                <!-- ESELON -->
                <v-col
                  cols="12"
                  md="6"
                  v-if="
                    sjj.atasan == 2 ||
                    sjj.id == 25 ||
                    sjj.id == 7 ||
                    sjj.id == 8
                  "
                >
                  <v-autocomplete
                    v-model="eselon"
                    :items="refeselon"
                    item-value="id"
                    item-text="nama"
                    label="Eselon"
                    prepend-inner-icon="mdi-sitemap-outline"
                    outlined
                    dense
                    hide-details="auto"
                    class="modern-field"
                  />
                </v-col>

                <!-- FUNGSIONAL -->
                <v-col
                  cols="12"
                  md="6"
                  v-if="
                    sjj.atasan == 13 ||
                    sjj.atasan == 14 ||
                    sjj.atasan == 19 ||
                    sjj.atasan == 28 ||
                    sjj.atasan == 29 ||
                    sjj.atasan == 34
                  "
                >
                  <v-autocomplete
                    v-model="fungsional"
                    :items="reffungsional"
                    item-value="id"
                    item-text="nama"
                    label="Jabatan Fungsional"
                    prepend-inner-icon="mdi-account-tie-outline"
                    outlined
                    dense
                    return-object
                    hide-details="auto"
                    class="modern-field"
                    @change="cfungsional"
                  />
                </v-col>

                <!-- PELAKSANA -->
                <v-col cols="12" md="6" v-if="sjj.atasan == 9 || sjj.id == 9">
                  <v-autocomplete
                    v-model="pelaksana"
                    :items="refpelaksana"
                    item-value="id"
                    item-text="nama"
                    label="Jabatan Pelaksana"
                    prepend-inner-icon="mdi-account-hard-hat-outline"
                    outlined
                    dense
                    return-object
                    hide-details="auto"
                    class="modern-field"
                    @change="cpelaksana"
                  />
                </v-col>

                <!-- NAMA JABATAN -->
                <v-col cols="12">
                  <v-text-field
                    v-model="namaJabatan"
                    label="Nama Jabatan"
                    prepend-inner-icon="mdi-text-box-outline"
                    placeholder="Masukkan nama jabatan"
                    outlined
                    dense
                    hide-details="auto"
                    class="modern-field"
                  />
                </v-col>
              </v-row>
            </section>

            <v-divider class="add-section-divider" />

            <!-- DETAIL KEBUTUHAN -->
            <section class="add-section">
              <div class="add-section-heading">
                <div class="add-section-icon detail-icon">
                  <v-icon>mdi-clipboard-list-outline</v-icon>
                </div>

                <div>
                  <h3>Detail Jabatan</h3>
                  <p>Atur batas usia, kelas, lokasi, dan kebutuhan pegawai.</p>
                </div>
              </div>

              <v-row dense>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model="bup"
                    label="Batas Usia Pensiun"
                    prepend-inner-icon="mdi-calendar-clock-outline"
                    type="number"
                    outlined
                    dense
                    hide-details="auto"
                    class="modern-field"
                  />
                </v-col>

                <v-col cols="12" sm="6" md="3">
                  <v-select
                    v-model="kelas_jabatan"
                    :items="refkelasjabatan"
                    item-value="id"
                    item-text="nama"
                    label="Kelas Jabatan"
                    prepend-inner-icon="mdi-layers-outline"
                    outlined
                    dense
                    hide-details="auto"
                    class="modern-field"
                  />
                </v-col>

                <v-col cols="12" sm="6" md="3">
                  <v-select
                    v-model="work_place"
                    :items="refworkplace"
                    item-value="id"
                    item-text="nama"
                    label="Work Place"
                    prepend-inner-icon="mdi-map-marker-outline"
                    outlined
                    dense
                    hide-details="auto"
                    class="modern-field"
                  />
                </v-col>

                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model="kebutuhan"
                    label="Kebutuhan Pegawai"
                    prepend-inner-icon="mdi-account-multiple-outline"
                    type="number"
                    outlined
                    dense
                    hide-details="auto"
                    class="modern-field"
                  />
                </v-col>
              </v-row>
            </section>
          </v-card-text>

          <!-- FOOTER -->
          <div class="add-modal-footer">
            <div class="footer-caption">
              <v-icon small class="mr-1"> mdi-information-outline </v-icon>
              Pastikan data sudah benar sebelum menyimpan.
            </div>

            <div class="footer-actions">
              <v-btn
                text
                color="grey darken-1"
                class="footer-cancel-btn"
                @click="close_modal"
              >
                Batal
              </v-btn>

              <v-btn
                depressed
                color="primary"
                class="footer-save-btn"
                :disabled="!atasan.id || lbtn"
                :loading="lbtn"
                @click="add()"
              >
                <v-icon left>mdi-content-save-outline</v-icon>
                Simpan Perubahan
              </v-btn>
            </div>
          </div>
        </template>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import "@/assets/styles/pages/anjab/petajab/petajab-add.css";

import Cookie from "@/helper/cookie.js";
import getRef from "@/helper/getReferensi.js";

import SData from "@/store/anjab/petajabatan";

export default {
  data: () => ({
    token: Cookie.get("token"),
    nama_unor: localStorage.getItem("nama_unor"),
    
    lbtn: false,
    loading: false,
    modal_jenjab: false,

    unor_nama: "",

    eselon: null,
    pelaksana: null,
    fungsional: null,

    id_jab_bkn: null,
    namaJabatan: null,
    janis_jabatan: null,
    bup: null,
    kelas_jabatan: null,
    work_place: null,
    kebutuhan: null,

    refeselon: [],
    refpimtinggi: [],
    refadmin: [],
    refpengawas: [],
    refpelaksana: [],
    reffungsional: [],

    refjj: [],
    seljj: [],
    refworkplace: [],
    refkelasjabatan: [],

    bawahan: [],

    // Data organisasi dari API
    petjab: [],

    // Pilihan atasan langsung untuk autocomplete
    pilihanAtasan: [],

    // Harus berupa object karena menggunakan return-object
    atasan: {
      id: null,
      title: "",
    },
  }),

  computed: {
    modal_add: {
      get() {
        return SData.state.modal_add;
      },
      set(value) {
        SData.commit("TModal", value);
      },
    },

    item: {
      get() {
        return SData.state.data;
      },

      set(value) {
        console.log(value);
      },
    },

    sjj() {
      if (!this.seljj.length) {
        return "kosong";
      } else {
        let data = {
          id: this.seljj[0].id,
          nama: this.seljj[0].nama,
          atasan: this.seljj[0].atasan,
          kelompok: this.seljj[0].kelompok,
        };
        return data;
      }
    },
  },

  watch: {
    async modal_add(value) {
      if (value) {
        this.refjj = await getRef.new_jj(this.token);
        this.refeselon = await getRef.eselon(this.token);
        this.refpimtinggi = await getRef.pimpinantinggi(this.token);
        this.refrefadmin = await getRef.administrator(this.token);
        this.refpengawas = await getRef.pengawas(this.token);
        this.reffungsional = await getRef.fungsional(this.token);
        this.refpelaksana = await getRef.new_pelaksana(this.token);
        this.refworkplace = await getRef.workplace(this.token);
        this.refkelasjabatan = await getRef.kelasjabatan(this.token);
        this.get_petjab();
      }
    },
  },

  methods: {
    cjj(value) {
      this.bawahan = value.bawahan;
    },

    clearjj() {
      this.$refs.pilihjj.reset();
    },

    cfungsional(value) {
      this.namaJabatan = value.nama;
      this.bup = value.bup;
    },

    cpelaksana(value) {
      this.namaJabatan = value.nama;
      this.bup = value.bup;
    },

    reset() {
      this.eselon = null;
      this.pelaksana = null;
      this.fungsional = null;

      this.namaJabatan = null;
      this.janis_jabatan = null;
      this.kebutuhan = null;

      this.refpimtinggi = [];
      this.refadmin = [];
      this.refpengawas = [];
      this.refpelaksana = [];
      this.reffungsional = [];

      this.refjj = [];
      this.seljj = [];
      this.bawahan = [];
    },

    flattenJabatan(data) {
      const result = [];

      function flatten(items) {
        items.forEach((item) => {
          const { bawahan, ...jabatan } = item;

          result.push(jabatan);

          if (Array.isArray(bawahan) && bawahan.length) {
            flatten(bawahan);
          }
        });
      }

      flatten(data);
      return result;
    },

    async get_petjab() {
      this.loading = true;

      const url = `${process.env.VUE_APP_API}/anjab/ref/unor/${this.item}`;

      try {
        const res = await this.axios.get(url, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        });

        this.petjab = this.flattenJabatan(res.data.mapData);
      } catch (error) {
        this.petjab = [];
        this.atasan = { id: null, title: "" };
      } finally {
        this.loading = false;
      }
    },

    async add() {
      this.lbtn = false;

      let data = {
        id_jab_bkn: this.id_jab_bkn,
        parent: this.atasan.id,
        namaJabatan: this.namaJabatan,
        unor: {
          id: this.$route.params.id,
        },
        janis_jabatan: {
          id: this.sjj.id,
        },
        eselon: {
          id: this.eselon,
        },
        pelaksana: {
          id: this.pelaksana ? this.pelaksana.id : null,
        },
        fungsional: {
          id: this.fungsional ? this.fungsional.id : null,
        },
        bup: this.bup,
        work_place: this.work_place,
        kelas_jabatan: this.kelas_jabatan,
        kebutuhan: this.kebutuhan,
      };

      const url = `${process.env.VUE_APP_API}/anjab/add`;

      this.axios
        .post(url, data, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((res) => {
          this.lbtn = true;
          if (res.data.success) {
            SData.commit("refresh", true);
            SData.commit("alert_text", "Berhasil Menambah Data");
            SData.commit("alert_b", true);
            SData.commit("alert_g", false);
          } else {
            SData.commit("refresh", true);
            SData.commit("alert_text", "Gagal Menambah Data");
            SData.commit("alert_g", true);
            SData.commit("alert_b", false);
          }

          this.close_modal();
        })
        .catch((error) => {
          SData.commit("refresh", true);
          SData.commit("alert_text", "Gagal Menambah Data");
          SData.commit("alert_g", true);
          SData.commit("alert_b", false);
          console.log(error.response.status);
          console.log("Error", error.message);
          this.lbtn = false;

          this.close_modal();
        });
    },

    async close_modal() {
      await SData.commit("refresh", true);
      this.reset();
      SData.commit("alert_g", false);
      SData.commit("alert_b", false);
      SData.commit("close_add", false);
    },
  },
};
</script>
